import { Menu } from '@headlessui/react';
import { Globe } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';
import { useContext } from 'react';
import { LanguageContext } from '../../contexts/LanguageContext';

const languages = {
  en: { name: 'English', flag: '🇬🇧' },
  hu: { name: 'Magyar', flag: '🇭🇺' },
  /* sr: { name: 'Српски', flag: '🇷🇸' },
  hr: { name: 'Hrvatski', flag: '🇭🇷' },
  sl: { name: 'Slovenščina', flag: '🇸🇮' },
  ro: { name: 'Română', flag: '🇷🇴' } */
};

export default function LanguageSwitcher() {
  const { language, setLanguage } = useContext(LanguageContext);

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="flex items-center px-3 py-2 text-sm text-gray-600 hover:text-gray-900">
        <span>{languages[language].flag}</span>
      </Menu.Button>

      <Menu.Items className="absolute right-0 z-10 mt-1 w-40 origin-top-right bg-white rounded-lg shadow-lg ring-1 ring-black/5 focus:outline-none">
        <div className="py-1">
          {Object.entries(languages).map(([code, { name, flag }]) => (
            <Menu.Item key={code}>
              {({ active }) => (
                <button
                  onClick={() => setLanguage(code)}
                  className={`${
                    active ? 'bg-gray-50 text-gray-900' : 'text-gray-600'
                  } ${
                    language === code ? 'font-medium' : ''
                  } flex w-full items-center px-4 py-2 text-sm`}
                >
                  <span className="mr-2">{flag}</span>
                  {name}
                </button>
              )}
            </Menu.Item>
          ))}
        </div>
      </Menu.Items>
    </Menu>
  );
} 